import { SearchObject } from "app/common/Model/SearchObject";
import {
  getVoucherItemSalesAllocation,
  pageOverViewReport,
} from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import { exportExcelDistributionGeneralReport } from "app/services/StaffRevenueService";
import { lockAndSendToHRMResult } from "app/services/VoucherItemService";
import { PositionType } from "app/common/LocalConst";

export default class RevenueSummaryByEmployeeStore {
  pageDataOverview = new PageResponse();
  searchRevenueSummaryByEmployee = {
    ...new SearchObject(),
    // fromDate: null,
    // toDate: null,
    listDepId: null,
    staffIds: [],
    staffId: [],
    voucherItemRevenueType: null
  };
  detailVoucherItems = []; // lưu chi tiết voucher
  loadingDetail = false;
  popupOpen = false;
  selectList = [];
  staffBranchManager = null;

  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchOverview = async (searchRevenueSummaryByEmployee) => {
    this.searchRevenueSummaryByEmployee = {
      ...this.searchRevenueSummaryByEmployee,
      ...searchRevenueSummaryByEmployee,
    };
    await this.pagingRevenueSummaryByEmployee();
  };

  getVoucherItemSalesDetail = async (staffId) => {
    this.loadingDetail = true;
    this.popupOpen = true;

    try {
      const search = this.normalizeSearchRevenueSummaryByEmployee({
        ...this.searchRevenueSummaryByEmployee,
        staffId: [staffId],
      });

      const { data } = await getVoucherItemSalesAllocation(search);
      this.detailVoucherItems = data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu chi tiết lỗi");
    } finally {
      this.loadingDetail = false;
    }
  };

  closePopupDetail = () => {
    this.popupOpen = false;
    this.detailVoucherItems = [];
  };

  pagingRevenueSummaryByEmployee = async () => {
    const search = this.normalizeSearchRevenueSummaryByEmployee(
      this.searchRevenueSummaryByEmployee
    );
    try {
      const { data } = await pageOverViewReport({ ...search });

      this.pageDataOverview = data;
      this.selectList = [];
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu cáo cáo doanh thu chi tiết (nguồn) có lỗi");
    }
  };

  normalizeSearchRevenueSummaryByEmployee = (rawSearch = {}) => {
    const { listDepId, staffId, ...rest } = rawSearch;

    // Chuẩn hóa listDepId thành mảng ID
    const normalizedListDepId = Array.isArray(listDepId)
      ? listDepId.map(item => item?.id ?? item) // nếu là object thì lấy id, nếu là string/number thì giữ nguyên
      : listDepId
        ? [listDepId?.id ?? listDepId]          // nếu là object riêng hoặc string/number
        : [];

    // Chuẩn hóa staffId thành mảng ID
    const normalizedStaffIds = Array.isArray(staffId)
      ? staffId.map(item => item?.id ?? item)
      : staffId
        ? [staffId?.id ?? staffId]
        : [];

    return {
      ...rest,
      listDepId: normalizedListDepId,
      staffIds: normalizedStaffIds,
    };
  };


  handleExportOverview = async (searchObj) => {
    try {
      const response = await exportExcelDistributionGeneralReport(
        this.normalizeSearchRevenueSummaryByEmployee({
          ...this.searchRevenueSummaryByEmployee,
          ...searchObj,
        })
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "BAO_CAO_DOANH_THU_CHI_TIET_THEO_NGUON_TONG_QUAT.xlsx"
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      } else {
        console.error("Export failed with status:", response.status);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  handleSyncHRM = async (searchObj) => {
    console.log("handleSyncHRM called", this.selectList, searchObj);

    try {
      let department = null; // dùng let vì bạn muốn gán lại
      if (searchObj?.listDepId) {
        department = searchObj.listDepId;
      }

      const salaryPeriod = searchObj?.salaryPeriodId;
      const items = this.selectList || [];

      const isDepartmentEmpty = !department || (Array.isArray(department) && department.length === 0);

      // Validate department, bỏ qua nếu positionType là TELESALE
      if (isDepartmentEmpty && searchObj?.positionType !== PositionType.TELESALE.value) {
        console.error("Không có cơ sở được chọn");
        return;
      }

      if (!salaryPeriod) {
        console.error("Không có kỳ lương được chọn");
        return;
      }

      if (!items.length) {
        console.error("Không có nhân viên nào được chọn");
        return;
      }

      const requestBody = {
        department,
        salaryPeriod,
        items,
        positionType: searchObj?.positionType,
      };

      const { data } = await lockAndSendToHRMResult(requestBody);

      if (data?.responseStatus) {
        console.log("Đồng bộ dữ liệu sang HRM thành công");
        this.selectList = []; // Reset sau khi đồng bộ
      } else {
        console.error("Cập nhật dữ liệu thất bại", data?.responseDetail || data);
      }
    } catch (error) {
      console.error("Lỗi khi đồng bộ dữ liệu sang HRM:", error);
    }
  };

  setSelectList = (value) => {
    if (Array.isArray(value)) {
      this.selectList = value;
    } else {
      this.selectList = [];
    }
  };

  setStaffBranchManager = (value) => {
    this.staffBranchManager = value;
  };

  resetStore = () => {
    this.listData = null;
    // this.searchRevenueSummaryByEmployee = {
    //   ...new SearchObject(),
    //   listDepId: [],
    //   // orgIds: [],
    // };
  };
}
